import axios from 'axios';
import Config from "../config/index";
import authHeader from "@/services/auth-header";

class TranslationService {
    items() {
        return axios.get(Config.apiBasePath + '/translations', {headers: authHeader()});
    }

    update(data) {
        return axios.put(Config.apiBasePath + '/translations', data, {headers: authHeader()});
    }

    getTranslationForLang(lang) {
        return axios.get(Config.apiBasePath + '/translations/' + lang).then(d2 => {
            return d2.data.data;
        });
    }

    getLanguageList() {
        return axios.get(Config.apiBasePath + '/translations/lang-list');
    }
}

export default new TranslationService();
